import AutoSubmit from "@stimulus-components/auto-submit";

export default class extends AutoSubmit {
    // static values = {
    //   delay: {
    //     type: Number,
    //     default: 1000, // You can change the default delay here.
    //   },
    // };

    // connect() {
    //     super.connect();
    //     console.log("auto_submit connected", this.element)
    // }

    submit(event) {
        console.log("submitting ....", event);

        const element = event.target;
        let hasValue;
        try {
            hasValue = element.matches(":autofill");
        } catch (err) {
            try {
                hasValue = element.matches(":-webkit-autofill");
            } catch (er) {
                hasValue = false;
            }
        }
        console.log("auto-submit hasvalue?", hasValue);

        // if (hasValue) {
        super.submit();
        // }
    }

    refresh(event) {
        console.log("refreshing with new variable", event.target.value);
        const currentUrl = new URL(window.location);
        currentUrl.searchParams.set(event.target.name, event.target.value);
        window.location.href = currentUrl.toString();
    }

    reload(event) {
        console.log("refreshing with new variable", event.target.value);
        const currentUrl = new URL(window.location);
        currentUrl.searchParams.set(event.target.name, event.target.value);
        if (this.formTarget) {
            this.formTarget.requestSubmit();
        }
    }
}
